module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-dusty-rose-5-eba65f794395af70068eab790859c199.webp";